import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n';
import { XCircle } from 'lucide-react';

const BoostCancelPage = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 text-center">
          <XCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
          <h2 className="text-xl font-bold mb-2">
            {language === 'cr' ? 'Paieman anilé' : 'Paiement annulé'}
          </h2>
          <p className="text-muted-foreground mb-6">
            {language === 'cr' 
              ? 'Ou la anilé lo paieman. Out post na pa été boosté.'
              : 'Vous avez annulé le paiement. Votre post n\'a pas été boosté.'}
          </p>
          <div className="flex gap-3 justify-center">
            <Button variant="outline" onClick={() => navigate('/feed')}>
              {language === 'cr' ? 'Rétourné lo fil' : 'Retour au fil'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BoostCancelPage;
